import React from 'react'
import { Outlet } from 'react-router-dom';


const LayOut = () => {
    return (
        <>
            <Outlet></Outlet>
            </>
    )
}

export default LayOut